import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Shell } from "../components/Shell.js";
import { isPageBlank, useEditor } from "../store.js";
import "../styles.css";
import samplePage from "./sample-page.json" with { type: "json" };

// Seed the sample page only if persist middleware rehydrated an empty
// blank state. If the user has real edits saved, don't clobber them.
if (isPageBlank()) {
  useEditor.getState().setPage(samplePage as never);
}

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");
createRoot(root).render(
  <StrictMode>
    <Shell />
  </StrictMode>,
);
